import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	listApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testplan/ls", params, successCallback, failCallback, exceptionCallback);
	},
	saveApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/tst/testplan/save", params, successCallback, failCallback, exceptionCallback);
	},
	toupdtApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testplan/toupdt", params, successCallback, failCallback, exceptionCallback);
	},
	updateApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/tst/testplan/update", params, successCallback, failCallback, exceptionCallback);
	},
	removeApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/tst/testplan/remove", params, successCallback, failCallback, exceptionCallback);
	},
	listProductsApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testplan/ls_prdts", params, successCallback, failCallback, exceptionCallback);
	},
	listPublishersApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testplan/list_publishers", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
